import { ExpenseNotCoveredStep } from "#/components/carrot-card-cost-share/steps/views/ExpenseNotCoveredStep"
import { WhatKindMetabolicCareStep } from "#/components/carrot-card-cost-share/steps/views/WhatKindMetabolicCareStep"
import { WhoWillReceiveCareStep } from "#/components/carrot-card-cost-share/steps/views/WhoWillReceiveCareStep"
import { GeneralSteps, MetabolicSteps, SectionName } from "#/components/carrot-card-cost-share/workflows/step-library"

export enum Workflows {
  METABOLIC = "Metabolic"
}

export const metabolicSteps = [
  { name: MetabolicSteps.WHO_WILL_RECEIVE_CARE_METABOLIC, component: WhoWillReceiveCareStep },
  { name: MetabolicSteps.WHAT_KIND_OF_METABOLIC_EXPENSE, component: WhatKindMetabolicCareStep },
  { name: MetabolicSteps.EXPENSE_NOT_COVERED_METABOLIC, component: ExpenseNotCoveredStep }
]

// prettier-ignore
const metabolicFlow: MetabolicFlowTransition[] = [
  { at: MetabolicSteps.WHO_WILL_RECEIVE_CARE_METABOLIC,   given: "ELIGIBLE",   goto: MetabolicSteps.WHAT_KIND_OF_METABOLIC_EXPENSE },
  { at: MetabolicSteps.WHO_WILL_RECEIVE_CARE_METABOLIC,   given: "INELIGIBLE", goto: MetabolicSteps.EXPENSE_NOT_COVERED_METABOLIC },
  { at: MetabolicSteps.WHAT_KIND_OF_METABOLIC_EXPENSE,    given: "",           goto: GeneralSteps.TOTAL_COST, sectionName: SectionName.GENERAL }
]

type MetabolicFlowTransition =
  | { at: MetabolicSteps; given: string; goto: MetabolicSteps; sectionName?: undefined }
  | { at: MetabolicSteps; given: string; goto: GeneralSteps; sectionName: string }
  | { at: MetabolicSteps; given: string; end: true }

export const metabolicWorkflows = [{ name: Workflows.METABOLIC, workflow: metabolicFlow }]
